export default __webpack_public_path__ + "static/media/lightIcon.8b4d0dea.svg";